// Lightweight error logger for otherwise-silent catch blocks.
// Surfaces swallowed failures in the browser console with context (useful during
// UAT/stress testing) without breaking the flow or showing UI noise to the user.
export function logError(context, err) {
  console.error(`[Claro] ${context}:`, err);
}
